import './AppChat.scss';
import classNames from 'classnames';
import React, { useCallback, useEffect, useMemo, useState } from 'react'
import Chat from '../generics/Chat';
import IconButton from '../common/IconButton';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { solid } from '@fortawesome/fontawesome-svg-core/import.macro';
import { ChatMessage } from '../../models/LLM';
import { Llm } from '../../api/Llm';
import { useToasts } from '../../contexts/toasts';
import { useAuth } from '../../contexts/auth';
import { Flex } from 'antd';

type Props = {
  show: boolean;
  onClose: VoidFunction;
}

export default function AppChat({ show, onClose }: Props) {
  const [history, setHistory] = useState<ChatMessage[]>([]);
  const [loading, setLoading] = useState(false);
  const [error] = useState(""); // setError needed?
  // TODO manage thread id based on selected chat?
  const [threadId, setThreadId] = useState<string>();

  const ragId = useMemo(() => window.__env.AI_CHAT__DEFAULT_RAG_ID || "224365", []);

  const { loggedUser } = useAuth();
  const { showToast } = useToasts();

  useEffect(() => setThreadId(loggedUser?.sub), [loggedUser]);

  const handleSendMessage = useCallback((message: ChatMessage) => {
    setLoading(true);
    setHistory(h => h.concat(message));

    const body = {
      context: {},
      input: { question: message.text },
      thread_id: threadId!,
    };

    Llm.invokeRag(ragId, body)
      .then(
        ({ data }) => {
          setLoading(false);
          setHistory(h => h!.concat({ timestamp: new Date().toISOString(), text: data.answer.content }));
        },
        (err) => {
          setLoading(false);
          const message = err.response?.data?.message || err.message;
          const status = err.response?.status;
          setHistory(h => h.concat({ text: message, isAlert: true, timestamp: new Date().toISOString() }));
          showToast('chat-invoke-error', message, `Invoke Error ${status ? `(${status})` : ''}`, 'danger');
        }
      );
  }, [showToast, threadId, ragId]);

  return (
    <nav className={classNames("app-chat", { open: show })}>
      <Chat
        history={history}
        loading={loading}
        onMessageSend={handleSendMessage}
        className="app-chat-container"
        emptyChatMessage="Hi, how can I help you?"
        error={error}
        extra={
          <div className="chat-header">
            <Flex align="center">
              <svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 24 24" strokeWidth={1} stroke="currentColor" className="title-icon">
                <path strokeLinecap="round" strokeLinejoin="round" d="M9.813 15.904 9 18.75l-.813-2.846a4.5 4.5 0 0 0-3.09-3.09L2.25 12l2.846-.813a4.5 4.5 0 0 0 3.09-3.09L9 5.25l.813 2.846a4.5 4.5 0 0 0 3.09 3.09L15.75 12l-2.846.813a4.5 4.5 0 0 0-3.09 3.09ZM18.259 8.715 18 9.75l-.259-1.035a3.375 3.375 0 0 0-2.455-2.456L14.25 6l1.036-.259a3.375 3.375 0 0 0 2.455-2.456L18 2.25l.259 1.035a3.375 3.375 0 0 0 2.456 2.456L21.75 6l-1.035.259a3.375 3.375 0 0 0-2.456 2.456ZM16.894 20.567 16.5 21.75l-.394-1.183a2.25 2.25 0 0 0-1.423-1.423L13.5 18.75l1.183-.394a2.25 2.25 0 0 0 1.423-1.423l.394-1.183.394 1.183a2.25 2.25 0 0 0 1.423 1.423l1.183.394-1.183.394a2.25 2.25 0 0 0-1.423 1.423Z" />
              </svg>
              <h6 className="ms-1 mb-0">AI Chat</h6>
            </Flex>

            <IconButton tooltip="Close" className="ms-auto p-1" onClick={onClose}>
              <FontAwesomeIcon icon={solid('times')} />
            </IconButton>
          </div>
        }
      />
    </nav>
  )
}